import { useGetUrl } from '@seek/ca-myprofile-utils';
import { metrics } from '@seek/metrics-js';
import { useTranslations } from '@vocab/react';
import {
  Text,
  Heading,
  Stack,
  Box,
  Column,
  Columns,
  PageBlock,
} from 'braid-design-system';
import { useEffect } from 'react';

import { ExternalLink } from 'src/components/ExternalLink/ExternalLink';
import { useAppConfig } from 'src/modules/appConfig';
import { browserLogInfo } from 'src/modules/error-logger/browserLog';

import translations from './.vocab';
import { ProfileLoadErrorIllustration } from './svg/ProfileLoadErrorIllustration';

export const ProfileLoadError = () => {
  const { t } = useTranslations(translations);
  const { zone, language } = useAppConfig();
  const getUrl = useGetUrl(zone, language);

  useEffect(() => {
    browserLogInfo('ProfileLoadError');
    metrics.count('profile-error-page-impression');
  }, []);

  return (
    <Box
      paddingTop={{ mobile: 'xlarge', tablet: 'xxxlarge' }}
      paddingBottom="xxxlarge"
      data-automation="error-page"
      background="surface"
    >
      <PageBlock width="medium">
        <Columns space="large" collapseBelow="tablet" reverse alignY="center">
          <Column width="1/2">
            <Box
              display="flex"
              justifyContent="center"
              paddingX={{ mobile: 'large', tablet: 'none' }}
            >
              <ProfileLoadErrorIllustration />
            </Box>
          </Column>
          <Column>
            <Box
              data-automation="error-page"
              display="flex"
              flexDirection={['column', 'row']}
              justifyContent="spaceBetween"
              textAlign={['center', 'left']}
            >
              <Stack space="medium">
                <Heading align={['center', 'left']} level="1" component="h1">
                  {t('Oops')}
                </Heading>
                <Heading align={['center', 'left']} level="4" component="h2">
                  {t('We’re having some technical issues')}
                </Heading>
                <Text align={['center', 'left']}>
                  {t('In the mean time, you...', {
                    LinkToHomePage: (v) => (
                      <ExternalLink href={getUrl('home-page')}>
                        {v}
                      </ExternalLink>
                    ),
                  })}
                </Text>
              </Stack>
            </Box>
          </Column>
        </Columns>
      </PageBlock>
    </Box>
  );
};
